import LiquidityWeekReport from "./LiquidityWeekReport.js";
import Model from "../../Model.js";

/**
 * A `liquidityReport` presents how much money is available in the
 * upcoming weeks to pay expenses (e.g., salaries and invoices).
 *
 * @param {LiquidityWeekReport[]} spec.weeks - Specifies values of the report for certain weeks
 * @param {number} spec.liquidity - Cash and bank balances, used bank overdraft included: (1900-1999)-(2330-2339)
 */
export default class LiquidityReport extends Model {
	constructor({ weeks, liquidity }) {
		super(...arguments);
		this._weeks = weeks;
		this._liquidity = liquidity;
	}

	getWeekReports() {
		return this._weeks;
	}

	getWeekReportAtIndex(index) {
		return this._weeks[index];
	}

	weekCount() {
		return this._weeks.length;
	}

	getLiquidity() {
		return this._liquidity;
	}

	_serializedProperties() {
		const properties = super._serializedProperties();

		properties.weeks = this._weeks;
		properties.liquidity = this._liquidity;

		return properties;
	}

	static transformMaterializationData(data, context) {
		data.weeks = LiquidityWeekReport.materializeAll(data.weeks, context);
		return data;
	}
}
